<template>
  <v-menu
    v-model="menu"
    offset-y
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-icon
        small
        :color="filter.length>0 ? 'primary' : ''"
        v-on="on"
      >
        arrow_drop_down
      </v-icon>
    </template>
    <v-card width="400">
      <v-card-text class="pa-2">
        <v-autocomplete
          v-model="filter"
          :items="filteredItems"
          :search-input.sync="search"
          :label="label"
          item-text="title"
          clearable
          menu-props="closeOnContentClick"
          return-object
          hide-details
          hide-selected
          no-data-text="Данные не выбраны"
          multiple
          small-chips
          outline
          :height="filter.length>0 ? 'auto' : '44'"
          class="ma-1"
        >
          <template v-slot:selection="data">
            <v-chip
              :selected="data.selected"
              close
              small
              @input="remove(data.item)"
            >
              {{ typeof data.item==='object' ? $options.filters.cropText(data.item.title, 30) : $options.filters.cropText(data.item, 30) }}
            </v-chip>
          </template>
        </v-autocomplete>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer />
        <v-btn
          color="primary"
          small
          @click="changeFilter"
        >
          Применить
        </v-btn>
        <v-btn
          small
          @click="menu=!menu"
        >
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  props: ["value", "label", "resource", "items"],
  data() {
    return {
      menu: false,
      filter: [],
      search: null,
      templateFilter: [],
    };
  },
  computed: {
    filteredItems() {
      if (!this.items.length) {
        return;
      }

      const items = [];
      this.items.forEach((i) => {
        if (!i[this.resource] || i[this.resource].id === 0) {
          return;
        }
        items.push(i[this.resource]);
      });
      return items;
    },
  },
  watch: {
    menu() {
      if (this.menu && this.templateFilter.lenght > 0) {
        this.filter = this.templateFilter;
      } else {
        this.filter = this.value;
      }
    },
    value: {
      handler() {
        this.filter = this.value;
      },
      immediate: true,
    },
  },
  methods: {
    remove(item) {
      const index = this.filter.indexOf(item);
      if (index >= 0) this.filter.splice(index, 1);
    },
    changeFilter() {
      this.templateFilter = this.filter;
      this.$emit("change", { filter: this.filter, resource: this.resource });
      this.menu = false;
    },
  },
};
</script>